// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/chunks/" + (chunkId === 106 ? "b9633c63" : chunkId) + "." + {"20":"23620af1ddb68737","106":"43f395d99202f17c","490":"dd15438a4186a886"}[chunkId] + ".js";
};